import type { CSSProperties } from 'react';
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = theme;

export interface ListingsHeaderRootCSS extends CSSProperties {
  '--listingsHeaderTop'?: string;
}

export const listingsHeaderRoot = css`
  position: sticky;
  top: var(--listingsHeaderTop, 36px);
  display: flex;
  align-items: center;
  column-gap: var(${themeVariables.spacing.sm});
  margin: 0 0 var(${themeVariables.spacing.sm});
  /* No right padding: the pills scroll out to the edge of the screen. */
  padding: var(${themeVariables.spacing.sm}) 0 var(${themeVariables.spacing.sm})
    var(${themeVariables.spacing.md});
  background-color: color-mix(in srgb, var(${themeVariables.colors.page.default}) 70%, transparent);
  backdrop-filter: blur(4px);
  z-index: 2;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0 -${spacing.md}px var(${themeVariables.spacing.sm});
    `,
  )};

  /* From here the sidebar does the filtering, pills and all. */
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: none;
    `,
  )};
`;

export const listingsHeaderSlot = css`
  flex: 1;
  min-width: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  /* A dark and a light translucent hairline side by side, so the divider stays faintly
     visible over whatever is showing through the translucent row. */
  box-shadow: inset 1px 0 0
      color-mix(in srgb, var(${themeVariables.colors.content.default}) 18%, transparent),
    inset 2px 0 0 color-mix(in srgb, white 50%, transparent);

  /* A page with no pills leaves just the button, without a divider beside it. */
  &:empty {
    display: none;
  }

  > * {
    flex: 1;
    min-width: 0;
  }
`;

/* The core Button puts no gap between its children. */
export const filtersCount = css`
  display: inline-flex;
  margin-left: var(${themeVariables.spacing.xxs});
`;
